import { GenericLookupType } from 'src/core/decorators/generic-lookup/generic-lookup-type.decorator';
import { GenericLookup } from 'src/core/decorators/generic-lookup/generic-lookup.decorator';

@GenericLookupType({
  code: 'Category.LookbackPeriodOption',
})
export class LookbackPeriodType {
  @GenericLookup({
      code: 'Category.LookbackPeriodOption.LastOneMonth',
  })
  static lastOneMonth: number;

  @GenericLookup({
      code: 'Category.LookbackPeriodOption.LastThreeMonths',
  })
  static lastThreeMonths: number;

  @GenericLookup({
      code: 'Category.LookbackPeriodOption.LastSixMonths',
  })
  static lastSixMonths: number;

  @GenericLookup({
      code: 'Category.LookbackPeriodOption.LastTwelveMonths',
  })
  static lastTwelveMonths: number;

  @GenericLookup({
      code: 'Category.LookbackPeriodOption.CustomInterval',
  })
  static customInterval: number;
}
